import { apiGet, apiPost, apiPatch, apiDelete } from '@/lib/api';

// Reports
export const getReports = () => apiGet('/reports');
export const createReport = (b) => apiPost('/reports', b);
export const createReportsBulk = (list) => apiPost('/reports/bulk', list);
export const updateReport = (id, patch) => apiPatch(`/reports/${id}`, patch);
export const deleteReport = (id) => apiDelete(`/reports/${id}`);

// Users / staff
export const getUsers = () => apiGet('/users');
export const createUser = (b) => apiPost('/users', b);
export const updateUser = (id, b) => apiPatch(`/users/${id}`, b);
export const deleteUser = (id) => apiDelete(`/users/${id}`);
export const setPin = (id, pin) => apiPost(`/users/${id}/set-pin`, { pin });
export const resetPin = (id) => apiPost(`/users/${id}/reset-pin`);

// Expenses
export const getDailyExpenses = (q = '') => apiGet(`/daily-expenses${q}`);
export const createDailyExpense = (b) => apiPost('/daily-expenses', b);
export const verifyDailyExpense = (id, verified) => apiPatch(`/daily-expenses/${id}`, { verified });
export const deleteDailyExpense = (id) => apiDelete(`/daily-expenses/${id}`);
export const getOfficeExpenses = (q = '') => apiGet(`/office-expenses${q}`);
export const createOfficeExpense = (b) => apiPost('/office-expenses', b);
export const verifyOfficeExpense = (id, verified) => apiPatch(`/office-expenses/${id}`, { verified });
export const deleteOfficeExpense = (id) => apiDelete(`/office-expenses/${id}`);

// Contacts (CRM)
export const getContacts = (q = '') => apiGet(`/contacts${q}`);
export const createContact = (b) => apiPost('/contacts', b);
export const updateContact = (id, b) => apiPatch(`/contacts/${id}`, b);
export const deleteContact = (id) => apiDelete(`/contacts/${id}`);
